// extracted by mini-css-extract-plugin
export default {"slots":"CustomBusinessHoursList_slots__8Kg-9","slot":"CustomBusinessHoursList_slot__+2oNx","empty":"CustomBusinessHoursList_empty__KhieH"};